import { render, staticRenderFns } from "./UploadPhoto.vue?vue&type=template&id=3f78f93c&scoped=true&lang=pug&"
import script from "./UploadPhoto.vue?vue&type=script&lang=js&"
export * from "./UploadPhoto.vue?vue&type=script&lang=js&"
import style0 from "./UploadPhoto.vue?vue&type=style&index=0&id=3f78f93c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f78f93c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAvatar,VCard,VContainer,VIcon,VImg,VProgressCircular,VSkeletonLoader})
